import { observer } from 'mobx-react-lite'
import { AllSelection } from 'prosemirror-state'
import { computed } from 'mobx'
import { useModals } from 'almanac-ui/Modal'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { ChangeLengthModal } from 'components/BlazeCommandLine/modals/ChangeLengthModal'
import { useAlmanacEditorState } from 'stores/EditorState'
import { useRootStore } from 'stores/RootStore'
import { AIAssistantProps } from '../Types'
import { Action, ActionProps } from './Action'
import { ChangeLength as ChangeLengthIcon } from 'blaze-ui/icons/36'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { FileBroken } from 'blaze-ui/icons/20'

export const ChangeLength = observer(function ChangeLength({
  article,
  layerId,
  ...props
}: AIAssistantProps & Omit<ActionProps, 'label' | 'tooltip'>) {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { openModal } = useModals()
  const editorState = useAlmanacEditorState()
  const { docStore } = useRootStore()

  const containsAiSuggestionNode = computed(() =>
    editorState?.allNodeTypes.has(editorState.view.state.schema.nodes.ai_suggestion),
  ).get()

  const handlePress = () => {
    if (!editorState || containsAiSuggestionNode) return

    const selection = editorState.selection.empty ? new AllSelection(editorState.view.state.doc) : editorState.selection

    if (
      selection.empty ||
      selection.content().content.textBetween(0, selection.content().content.size).trim().length < 1
    ) {
      showToastMessage(`Try selecting some text you'd like Blaze to change length!`, 'info')
      return
    }

    if (!docStore?.rightRailStore.locked) {
      docStore?.rightRailStore.setActiveTab(undefined)
    }

    openModal(ChangeLengthModal, {
      articleId: article.id,
      layerId,
      selection: selection.toJSON(),
      almanacEditorState: editorState,
    })
  }

  return (
    <Action
      tooltip={
        containsAiSuggestionNode
          ? 'Click Done to accept your generated content before changing length'
          : 'Select a new target length for your doc'
      }
      label="Change Length"
      icon={isSystemRedesignEnabled ? FileBroken : ChangeLengthIcon}
      isDisabled={containsAiSuggestionNode}
      {...props}
      onPress={handlePress}
    />
  )
})
